module.exports = __webpack_public_path__ + "static/media/TwoM.aab5dfc8.png";